<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM14.5858 15.9998L11.7573 18.8282L11.7573 18.8282L11.7573 18.8283L13.1715 20.2425L16 17.414L18.8286 20.2426L20.2428 18.8284L20.2428 18.8284L20.2428 18.8284L17.4143 15.9998L20.2426 13.1714L20.2426 13.1714L20.2426 13.1714L18.8284 11.7572L16 14.5855L13.1718 11.7573L11.7576 13.1715L11.7576 13.1715L11.7576 13.1715L14.5858 15.9998Z"
        />
    </svg>
</template>
